export const ButtonStyles = {
  // Can simply pass default props to change default behaviour of components.
  baseStyle: () => ({
    rounded: "md",
  }),
  defaultProps: {
    variant: "primary",
    py: "18",
    colorScheme: "primary",
  },
  variants: {
    primary: ({ colorScheme, size }: any) => ({
      _light: {
        bg: `${colorScheme}.500`,
      },
      _text: {
        color: "white",
      },
      _icon: {
        color: "white",
      },
      _hover: {
        bg: `${colorScheme}.pressed`,
      },
      _pressed: {
        bg: `${colorScheme}.pressed:alpha.80`,
      },
      _disabled: {
        background: "neutrals.800",
        _text: {
          color: "neutrals.900",
        },
      },
    }),
    secondary: ({ colorScheme, size }: any) => ({
      _light: {
        bg: `neutrals.700`,
      },
      _text: {
        color: "black",
      },
      _icon: {
        color: "black",
      },
      _hover: {
        bg: "grayscale.500",
      },
      _pressed: {
        bg: `grayscale.500:alpha.80`,
      },
      _disabled: {
        background: "neutrals.800",
        _text: {
          color: "neutrals.900",
        },
      },
    }),
    tertiary: ({ colorScheme, size }: any) => ({
      _light: {
        bg: `white`,
        borderWidth: "1px",
        borderColor: "neutrals.900",
      },
      _text: {
        color: "black",
      },
      _icon: {
        color: "black",
      },
      _hover: {
        bg: "events.greenLight",
        borderColor: "#5cc1ad",
      },
      _pressed: {
        bg: `events.greenLight:alpha.20`,
      },
      _disabled: {
        background: "neutrals.800",
        _text: {
          color: "neutrals.900",
        },
      },
    }),
    flat: ({ colorScheme, size }: any) => ({
      _icon: {
        color: "neutrals.300",
      },
      _text: {
        color: "neutrals.300",
      },
      _spinner: {
        color: `${colorScheme}.600`,
      },
      _hover: {
        bg: `${colorScheme}.600:alpha.10`,
      },
      _pressed: {
        bg: `${colorScheme}.600:alpha.20`,
      },
    }),
  },
  sizes: {
    md: {
      _text: {
        fontSize: 16,
      },
    },
    lg: {
      _text: {
        fontSize: 20,
      },
    },
  },
};
